import { taggedTemplateLiteralLoose as _taggedTemplateLiteralLoose } from '../_virtual/_rollupPluginBabelHelpers.js';
import { Global, css } from '@emotion/react';
import React__default from 'react';
import { theme } from '@stacks/ui-theme';
import { generateCssVariables } from './utils.esm.js';

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n      * {\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n      }\n      html {\n        background: var(--colors-bg);\n        border-color: var(--colors-border);\n\n        &.light {\n          ", ";\n          --colors-highlight-line-bg: rgba(255, 255, 255, 0.08);\n          * {\n            -webkit-font-smoothing: antialiased;\n            -moz-osx-font-smoothing: grayscale;\n          }\n        }\n        &.dark {\n          ", ";\n          --colors-highlight-line-bg: rgba(255, 255, 255, 0.04);\n          * {\n            -webkit-font-smoothing: subpixel-antialiased;\n            -moz-osx-font-smoothing: auto;\n          }\n        }\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      :root {\n        ", ";\n        --colors-highlight-line-bg: rgba(255, 255, 255, 0.05);\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n      :root {\n        ", ";\n        --colors-highlight-line-bg: rgba(255, 255, 255, 0.08);\n      }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var LightMode = /* @__PURE__ */React__default.createElement(Global, {
  styles: /*#__PURE__*/css( /*#__PURE__*/_templateObject(), /*#__PURE__*/generateCssVariables("light")({
    colorMode: "light",
    theme: theme
  }))
});
var DarkMode = /* @__PURE__ */React__default.createElement(Global, {
  styles: /*#__PURE__*/css( /*#__PURE__*/_templateObject2(), /*#__PURE__*/generateCssVariables("dark")({
    colorMode: "dark",
    theme: theme
  }))
});
var BaseStyles = /* @__PURE__ */React__default.createElement(Global, {
  styles: /*#__PURE__*/css( /*#__PURE__*/_templateObject3(), /*#__PURE__*/generateCssVariables("light")({
    colorMode: "light",
    theme: theme
  }), /*#__PURE__*/generateCssVariables("dark")({
    colorMode: "dark",
    theme: theme
  }))
});
var ColorModes = /*#__PURE__*/React__default.memo(function () {
  return /* @__PURE__ */React__default.createElement(React__default.Fragment, null, /* @__PURE__ */React__default.createElement("style", {
    "data-emotion-css": "css-global " + DarkMode.props.styles.name,
    dangerouslySetInnerHTML: {
      __html: DarkMode.props.styles.styles
    },
    media: "(prefers-color-scheme: dark)"
  }), /* @__PURE__ */React__default.createElement("style", {
    "data-emotion-css": "css-global " + LightMode.props.styles.name,
    dangerouslySetInnerHTML: {
      __html: LightMode.props.styles.styles
    },
    media: "(prefers-color-scheme: light)"
  }), BaseStyles);
});

export { BaseStyles, ColorModes, DarkMode, LightMode };
//# sourceMappingURL=styles.esm.js.map
